
import { defineComponent } from "vue";
export default defineComponent({
  emits: ["clicked"],
  methods: {
    clicked() {
      // TODO: WARN: stupid and hacky temporary solution that will
      // break once an inventory is introduced
      (
        (this.$parent?.$refs.audioCancelConfirm ||
          document.getElementById(
            "audioExitDialogDEPRECATED"
          )) as HTMLAudioElement
      ).play();
      this.$emit("clicked");
    },
  },
});
